export default __webpack_public_path__ + "static/media/countdown.ca29e78d.jpg";